import { Component } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaWhatsapp,
  FaGoogleDrive,
} from "react-icons/fa";

const HeaderSocials = ({ links }) => {
  return (
    <div className="header__socials">
      <a href={links.twitter} target="_blank" rel="noopener noreferrer">
        <FaTwitter />
      </a>
      <a href={links.instagram} target="_blank" rel="noopener noreferrer">
        <FaInstagram />
      </a>
      <a href={links.whatsapp} target="_blank" rel="noopener noreferrer">
        <FaWhatsapp />
      </a>
      <a href={links.drive} target="_blank" rel="noopener noreferrer">
        <FaGoogleDrive />
      </a>
    </div>
  );
};

export default HeaderSocials;
